module.exports = __webpack_public_path__ + "static/media/waypoint_y.da7f1f8d.svg";